/**
 * @generated SignedSource<<a8727d0d9c8e787e0ce1081cd488c096>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "includeService"
  }
],
v1 = [
  {
    "condition": "includeService",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "Service",
        "kind": "LinkedField",
        "name": "serviceById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameUk",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "details",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tags",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceListServiceByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceListServiceByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0dad8b4238764677e394e4985465590e",
    "id": null,
    "metadata": {},
    "name": "serviceListServiceByIdQuery",
    "operationKind": "query",
    "text": "query serviceListServiceByIdQuery(\n  $id: String\n  $includeService: Boolean = true\n) {\n  serviceById(id: $id) @include(if: $includeService) {\n    id\n    name\n    nameUk\n    details\n    tags\n  }\n}\n"
  }
};
})();

node.hash = "6dfd0acba5d965ae592df2b74514abb3";

module.exports = node;
